import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { APDegreeMapQuery } from '../degree_map/queries/ap_degree_map_query';
import { SetSelectedPlannerResourceTabCommand } from './commands/set_selected_planner_resource_tab_command';
import { PlannerResourceMAPTab, PlannerResourceSearchTab } from './constants/planner_resource_tabs';
import { APPlannerResourceTabsQuery } from './queries/planner_resource_tabs_query';

export class APPlannerResourcesController {
  private isEditable: boolean | string;
  private isSmartCatalogEnabled: boolean = false;
  private isSearchEnabled: boolean = true;

  private trackSearchToggle: boolean = false;
  private shouldShowGoalSets = false;

  constructor(
    private appConfigModel: any,
    private ngAPDegreeMapQuery: APDegreeMapQuery,
    private ngAPPlannerResourceTabsQuery: APPlannerResourceTabsQuery,
    private setSelectedPlannerResourceTabCommand: SetSelectedPlannerResourceTabCommand
  ) {}

  $onInit() {
    this.isSmartCatalogEnabled = this.appConfigModel.isFeatureEnabled('academicplan-smart_catalog');
    this.isSearchEnabled = this.appConfigModel.isFeatureEnabled('reg-course_search');
    this.shouldShowGoalSets = this.appConfigModel.isFeatureEnabled('cat-show_student_goal_sets');
  }

  isDegreeMapEmpty() {
    return this.ngAPDegreeMapQuery.result.isDegreeMapEmpty;
  }

  $onChanges() {
    this.isSmartCatalogEnabled = this.appConfigModel.isFeatureEnabled('academicplan-smart_catalog');
    this.isSearchEnabled = this.appConfigModel.isFeatureEnabled('reg-course_search');
    this.isEditable = _4.isBoolean(this.isEditable) ? this.isEditable : this.isEditable === 'true';
    if (this.isEditable && (this.isSearchEnabled || this.isSmartCatalogEnabled) && this.isDegreeMapEmpty()) {
      this.setSelectedPlannerResourceTabCommand(PlannerResourceSearchTab.key);
      this.trackSearchToggle = true;
    } else {
      this.setSelectedPlannerResourceTabCommand(PlannerResourceMAPTab.key);
    }
  }
}

class APPlannerResources implements ng.IComponentOptions {
  public controller: any;
  public templateUrl: any;
  public bindings: any;

  constructor() {
    this.controller = APPlannerResourcesController;
    this.templateUrl = 'capability-ng-academic-planner/src/plan/components/planner_resources/planner_resources.html';
    this.bindings = {
      isEditable: '<?'
    };
  }
}

angular.module('capability-ng-academic-planner').component('apPlannerResources', new APPlannerResources());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/planner_resources/planner_resources.ts